<template>
	<section class="py-5">
		<div class="container py-md-3 portfolio">
			<div class="container">
				<h3 class="heading mb-4">模拟测评</h3>
				<div class="row">
					<div class="col-lg-12">
						<ul id="portfolio-flters">
							<li :class="{filter_active:0 == anliIndex}" @click="getAllAnli(0)">全部</li>
							<li :class="{filter_active:1 == anliIndex}" @click="getAnli(1)">机器人一级</li>
							<li :class="{filter_active:2 == anliIndex}" @click="getAnli(2)">机器人二级</li>
						</ul>
					</div>
				</div>
				<div class="inner-sec-w3lss my-lg-5 my-3" v-for="item of anliList" :key="item.id">
					<div class="row">
						<div class="col-lg-3 video-img mt-lg-0 mt-4">
							<img :src="item.testPic" alt="" class="img-fluid">
						</div>
						<div class="col-lg-9 news-content px-lg-4 px-2">
							<h3 class="tittle-w3 pt-3">{{item.testName}}</h3>
							<p class="mt-2">{{item.testDesc}}</p>
							<div class="news-link">
								<a href="javascript:void(0)" class="btn mr-2 text-capitalize ml-2" @click="more(item.id)">开始测评</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import axios from 'axios'
	var header = CommonHeader
	export default {
		name: 'TestContent',
		data() {
			return {
				testContentList: [],
				anliList: [],
				anliIndex: 0
			}
		},
		methods: {
			more(id) {
				if(this.$store.state.loginFlag) {
					this.$router.push({
						path: '/robot/test/dotest?tid=' + id
					})
				} else {
					//					header.methods.login()
					this.$router.push({
						path: '/robot/test/dotest?tid=' + id
					})
				}
			},
			getAllAnli(i) {
				this.anliIndex = i
				this.anliList = this.testContentList
			},
			getAnli(i) {
				this.anliIndex = i
				let arr = []
				for(var o of this.testContentList) {
					if(o.testType == i) {
						arr.push(o)
					}
				}
				this.anliList = arr
			},
			getDataInfo() {
				axios.get('/itmswcn/learn/robot/test/queryAll')
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				res = res.data
				if(res.code == 100 && res.data) {
					this.testContentList = res.data
					this.anliList = this.testContentList
				}
			}
		},
		mounted() {
			this.getDataInfo()
		}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/robot/components/TestContent.scss';
	.portfolio {
		padding-bottom: 80px;
	}
	
	.portfolio .portfolio-item {
		margin-bottom: 30px;
	}
	
	.portfolio #portfolio-flters {
		padding: 0;
		margin: 20px 0 5px;
		list-style: none;
		text-align: left;
	}
	
	.portfolio #portfolio-flters li {
		cursor: pointer;
		margin: 0 5px 5px 0;
		display: inline-block;
		padding: 10px 15px;
		font-size: 20px;
		font-weight: 600;
		line-height: 20px;
		color: #444444;
		margin-bottom: 5px;
		transition: all 0.3s ease-in-out;
		letter-spacing: 1px;
	}
	
	.portfolio #portfolio-flters li:hover,
	.portfolio #portfolio-flters li.filter_active {
		color: #fdc134;
	}
	
	.portfolio #portfolio-flters li:last-child {
		margin-right: 0;
	}
	
	.portfolio .portfolio-wrap {
		transition: 0.3s;
		position: relative;
		overflow: hidden;
		border-radius: 8px;
		z-index: 1;
		cursor: pointer;
	}
	
	.portfolio .portfolio-wrap::before {
		content: "";
		background: rgba(33, 59, 82, 0.6);
		position: absolute;
		left: 100%;
		right: 0;
		top: 0;
		bottom: 0;
		transition: all ease-in-out 0.3s;
		z-index: 2;
	}
	
	.portfolio .portfolio-wrap img {
		transition: 0.3s;
	}
	
	.portfolio .portfolio-wrap .portfolio-links {
		opacity: 0;
		left: 0;
		right: 0;
		top: calc(50% - 36px);
		text-align: center;
		z-index: 3;
		position: absolute;
		transition: all ease-in-out 0.3s;
	}
	
	.portfolio .portfolio-wrap .portfolio-links a {
		color: #fdc134;
		font-size: 24px;
		line-height: 1;
		text-align: center;
		width: 36px;
		height: 36px;
		display: inline-block;
		transition: 0.3s;
	}
	
	.portfolio .portfolio-wrap .portfolio-links a:hover {
		color: #fff;
	}
	
	.portfolio .portfolio-wrap .portfolio-info {
		opacity: 0;
		position: absolute;
		top: 90px;
		left: 0;
		right: 0;
		text-align: center;
		z-index: 3;
		transition: all ease-in-out 0.3s;
	}
	
	.portfolio .portfolio-wrap .portfolio-info h4 {
		font-size: 20px;
		color: #fff;
		font-weight: 600;
		letter-spacing: 2px;
		margin-bottom: 18px;
	}
	
	.portfolio .portfolio-wrap .portfolio-info p {
		color: #ffffff;
		font-size: 15px;
		text-transform: uppercase;
		letter-spacing: 2px;
		line-height: 28px;
		padding-left: 15px;
		padding-right: 15px;
	}
	
	.portfolio .portfolio-wrap:hover::before {
		left: 0;
	}
	
	.portfolio .portfolio-wrap:hover .portfolio-links {
		opacity: 1;
		top: calc(50% - 18px);
	}
	
	.portfolio .portfolio-wrap:hover .portfolio-info {
		opacity: 1;
		bottom: 0;
	}
</style>